namespace TabAurous.Retail {
    export interface GiftVoucherSalesReceiptRow {
        Id?: number;
        TransId?: number;
        ModeId?: number;
        LedgerId?: number;
        Code?: string;
        Amount?: number;
        RefNo?: string;
        ChequeNo?: number;
        ChequeDate?: string;
        Scheme?: string;
        RefTransId?: number;
        RefVoucherType?: number;
        SchemeEnrollmentId?: number;
    }

    export namespace GiftVoucherSalesReceiptRow {
        export const idProperty = 'Id';
        export const nameProperty = 'RefNo';
        export const localTextPrefix = 'Retail.GiftVoucherSalesReceipt';
        export const lookupKey = 'Retail.GiftVoucherSalesReceipt';

        export function getLookup(): Q.Lookup<GiftVoucherSalesReceiptRow> {
            return Q.getLookup<GiftVoucherSalesReceiptRow>('Retail.GiftVoucherSalesReceipt');
        }
        export const deletePermission = 'Retail:GiftVoucherSales:Delete';
        export const insertPermission = 'Retail:GiftVoucherSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherSales:Edit';

        export declare const enum Fields {
            Id = "Id",
            TransId = "TransId",
            ModeId = "ModeId",
            LedgerId = "LedgerId",
            Code = "Code",
            Amount = "Amount",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Scheme = "Scheme",
            RefTransId = "RefTransId",
            RefVoucherType = "RefVoucherType",
            SchemeEnrollmentId = "SchemeEnrollmentId"
        }
    }
}
